import React, { useEffect, useState } from "react";
import {
  OptionItem,
  TextSwitch,
} from "../../../../../components/TextSwitch/TextSwitch";
import {
  CollaboratorIncreasingEnum,
  CollaboratorResume,
  CollaboratorsCmSheetFinalInterview,
  GetCollaboratorCmSheetsResponse,
  internalGradeType,
  UpdateCollaboratorResumeRequest,
} from "../../../../../types/api/collaborators.type";
import { useAppSelector } from "../../../../../hooks/store.hook";
import { useNotification } from "../../../../../hooks/notification.hook";
import { PermissionsEnum } from "../../../../../constants/AppConstants";
import {
  CANCEL_LABEL,
  CCNL_LEVELL_PASS_LABEL,
  DATA_ADDED_SUCCESS_LABEL,
  DEVELOPMENT_SCREEN_LABEL,
  EDIT_LABEL,
  EMPTY_DEVELOPMENT_SCREEN_LABEL,
  EMPTY_STRING,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
  GRADE_LABEL,
  INCREASE_LABEL,
  INTERNAL_GRADE_END_LABEL,
  INTERNAL_GRADE_PASS_LABEL,
  JOB_FAMILY_LABEL,
  MODIFY_RESUME_DEVELOPMENT_PLAN_LABEL,
  MODIFY_RESUME_DEVELOPMENT_PLAN_MESSAGE,
  NO_LABEL,
  PATH_LABEL,
  PRINT_LABEL,
  PROGRESS_PLAN_LABEL,
  PROPOSAL_STEPS_INCREASER_LABEL,
  SAVE_LABEL,
  SUBGRADE_LABEL,
  TO_EVALUATE_LABEL,
  TOTAL_LABEL,
  VALUTATION_MATRIX_OF_DEVELOPMENT_LABEL,
  YES_LABEL,
} from "../../../../../constants/Dictionary";
import {
  Button,
  ButtonSizes,
  ButtonVariants,
} from "../../../../../components/core/Button/Button";
import {
  StyledBtnEditContainer,
  StyledBtnModifyContainer,
  StyledProgressPlanBody,
  StyledProgressPlanHeader,
  StyledWorkInformationTitle,
} from "../Resume.styled";
import { IconManager } from "../../../../../components/core/IconManager/IconManager";
import {
  CollaboratorInfo,
  FontWeightEnum,
  IconSizeEnum,
} from "../../../../../types/AppTypes";
import { theme } from "../../../../../constants/StyledComponents";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import { InfoContainer } from "../../../../../components/core/InfoContainer/InfoContainer";
import {
  Select,
  SelectOption,
  SelectVariantEnum,
} from "../../../../../components/core/Select/Select";
import { InputSizes } from "../../../../../components/core/Input/Input";
import { RadioButton } from "../../../../../components/core/RadioButton/RadioButton";
import { roleHasPermission } from "../../../../../utils/roleAuth.utils";
import { ReactComponent as ProgressIcon } from "../../../../../icons/potential_matrix.svg";
import { ReactComponent as EditIcon } from "../../../../../icons/pencil.svg";
import { ReactComponent as SaveIcon } from "../../../../../icons/save.svg";
import { ReactComponent as CloseIcon } from "../../../../../icons/close.svg";
import { ReactComponent as PrintIcon } from "../../../../../icons/print.svg";
import { ReactComponent as InternalGradeIcon } from "../../../../../icons/internalGrade.svg";
import { ReactComponent as QuadrantIcon } from "../../../../../icons/quadrant.svg";
import { ReactComponent as CheckIcon } from "../../../../../icons/check.svg";
import { ReactComponent as EvaluateIcon } from "../../../../../icons/evaluate.svg";
import {
  StyledBodyProgressPlan,
  StyledIncreasingRadioGroup,
  StyledIncreasingRadioOption,
  StyledRowIncreasing,
  StyledValutationQuadrantBody,
  StyledValutationQuadrantContainer,
  StyledValutationQuadrantSelect,
  StyledValutationQuadrantTotal,
  StyledRowIncreasingContainer,
  StyledGridContainer,
} from "./ProgressPlan.styled";
import { PendingCalibration } from "../../../../../components/CalibrationModal/CalibrationModal";
import { PopupConfirm } from "../../../../../components/PopupConfirm/PopupConfirm";
import {
  Accordion,
  AccordionVariantEnum,
} from "../../../../../components/core/Accordion/Accordion";
import { TextBox } from "../../../../../components/TextBoxGrid/TextBoxGrid.component";
import { FinalInterviewInfo } from "../../SchedaCM/FinalInterview/FinalInterview";
interface ProgresPlanProps {
  data: CollaboratorResume | null;
  collaborator: CollaboratorInfo;
  selectedYear: OptionItem<number>;
  setSelectedYear?: (year: OptionItem<number>) => void;
  yearOptions?: OptionItem<number>[];
  loading: boolean;
  editButton?: {
    visible: boolean;
    disabled: boolean;
  };
  planSelected: CollaboratorsCmSheetFinalInterview | null;
  btnEditIsToView?: boolean;
  onSubmitResume?: (data: UpdateCollaboratorResumeRequest) => void;
  printButton?: (component: React.ReactNode) => void;
  collaboratorCmSheets?: GetCollaboratorCmSheetsResponse | null;
  pendingCalibration?: PendingCalibration;
  onCalibrationChange?: (x: PendingCalibration | null) => void;
  print?: () => void;
  updateResume?: (body: UpdateCollaboratorResumeRequest) => Promise<void>;
  endInternalGrade?: internalGradeType;
  isComparison?: boolean;
  onResumeChange?: (body: UpdateCollaboratorResumeRequest) => void;
  pendingResume?: UpdateCollaboratorResumeRequest;
}

export const ProgressPlan = ({
  data,
  collaborator,
  collaboratorCmSheets,
  planSelected,
  selectedYear,
  setSelectedYear,
  yearOptions,
  btnEditIsToView = true,
  loading,
  editButton,
  printButton,
  print,
  updateResume,
  endInternalGrade,
  isComparison = false,
  pendingCalibration,
  onCalibrationChange,
  onResumeChange,
  pendingResume,
}: ProgresPlanProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);
  const [editedIndicators, setEditedIndicators] = useState<number[]>([]);
  const [editedIncreasings, setEditedIncreasings] = useState<{
    internalGradeIncrease: CollaboratorIncreasingEnum | null;
    ccnlIncrease: CollaboratorIncreasingEnum | null;
    salaryIncrease: CollaboratorIncreasingEnum | null;
  }>({
    internalGradeIncrease: null,
    ccnlIncrease: null,
    salaryIncrease: null,
  });
  const [editedEndInternalGrade, setEditedEndInternalGrade] = useState<{
    jobFamilyListId: number[];
    gradeId: number | null;
    pathGradeId: number | null;
    subgradeId: number | null;
  }>({
    jobFamilyListId: [],
    gradeId: null,
    pathGradeId: null,
    subgradeId: null,
  });

  const cmSheetIsCurrent = collaboratorCmSheets?.find(
    (item) => item.configYear === selectedYear.value,
  )?.isCurrent;

  const localResume = cmSheetIsCurrent ? pendingResume : undefined;

  const serverIncreasings = {
    internalGradeIncrease:
      data?.collaboratorIncreasings.internalGradeIncrease ?? null,
    ccnlIncrease: data?.collaboratorIncreasings.ccnlIncrease ?? null,
    salaryIncrease: data?.collaboratorIncreasings.salaryIncrease ?? null,
  };

  const serverEndInternalGrade = {
    jobFamilyListId: data?.internalGrade.end?.jobFamilyListId ?? [],
    gradeId: data?.internalGrade.end?.gradeId ?? null,
    pathGradeId: data?.internalGrade.end?.pathGradeId ?? null,
    subgradeId: data?.internalGrade.end?.subgradeId ?? null,
  };

  const initialEditedFields = {
    indicators:
      localResume?.indicators.map((item) => item.total) ??
      planSelected?.developmentScreen?.indicators.map((item) => item.total) ??
      [],
    increasings: localResume?.collaboratorIncreasings ?? serverIncreasings,
    endInternalGrade: localResume
      ? {
          jobFamilyListId: localResume.endInternalGrade.jobFamilyListId,
          gradeId: localResume.endInternalGrade.gradeId,
          pathGradeId: localResume.endInternalGrade.pathGradeId,
          subgradeId: localResume.endInternalGrade.subgradeId,
        }
      : serverEndInternalGrade,
  };

  const resetEditedFields = () => {
    setEditedIndicators(initialEditedFields.indicators);
    setEditedIncreasings(initialEditedFields.increasings);
    setEditedEndInternalGrade(initialEditedFields.endInternalGrade);
  };

  const isDirty =
    JSON.stringify({
      indicators: editedIndicators,
      increasings: editedIncreasings,
      endInternalGrade: editedEndInternalGrade,
    }) !== JSON.stringify(initialEditedFields);

  const { notification } = useNotification();

  const { profile } = useAppSelector((state) => state.user);
  const { config } = useAppSelector((state) => state.config);

  const selectedYearConfig = config.find(
    (item) => item.year === selectedYear?.value,
  )?.config;

  const computePendingEndGradeLabels = (): internalGradeType => {
    const grade = initialEditedFields.endInternalGrade;
    if (!selectedYearConfig) {
      return (
        endInternalGrade ?? {
          jobFamilies: null,
          grade: null,
          path: null,
          subGrade: null,
        }
      );
    }

    const jobFamilies = grade.jobFamilyListId.length
      ? selectedYearConfig.jobFamilies
          .filter((item) => grade.jobFamilyListId.includes(item.id))
          .map((item) => item.name)
          .join(", ")
      : null;

    const gradeName = grade.gradeId
      ? (selectedYearConfig.grades.find((item) => item.id === grade.gradeId)
          ?.name ?? null)
      : null;

    const pathGrade = grade.pathGradeId
      ? selectedYearConfig.pathGrades.find(
          (item) => item.id === grade.pathGradeId,
        )
      : undefined;

    const pathName = pathGrade
      ? (selectedYearConfig.paths.find((item) => item.id === pathGrade.pathId)
          ?.name ?? null)
      : null;

    const pathGradeName = pathGrade?.name ?? null;

    const path =
      pathName && pathGradeName
        ? `${pathName} - ${pathGradeName}`
        : (pathName ?? pathGradeName ?? null);

    const subGrade = grade.subgradeId
      ? (selectedYearConfig.subgrades.find(
          (item) => item.id === grade.subgradeId,
        )?.name ?? null)
      : null;

    return { jobFamilies, grade: gradeName, path, subGrade };
  };

  const displayEndInternalGrade = localResume
    ? computePendingEndGradeLabels()
    : endInternalGrade;

  const getPathOptions = (selectedGradeId?: number | null) => {
    if (selectedGradeId == null || !selectedYearConfig) {
      return [];
    }

    const options: SelectOption<number>[] = [];
    const grade = selectedYearConfig.grades.find(
      (item) => item.id === Number(selectedGradeId),
    );

    if (grade) {
      selectedYearConfig.pathGrades
        .filter((pathGrade) => pathGrade.gradeId === grade.id)
        .forEach((pathGrade) => {
          const path = selectedYearConfig.paths.find(
            (item) => item.id === pathGrade.pathId,
          );

          if (path) {
            options.push({
              label: `${path.name} - ${pathGrade.name}`,
              value: pathGrade.id,
            });
          }
        });
    }

    return options;
  };

  const startGrade = selectedYearConfig?.grades.find(
    (item) => item.id === data?.internalGrade.start?.gradeId,
  );

  const endGradeOptions = (selectedYearConfig?.grades ?? [])
    .filter((item) => !startGrade || item.position >= startGrade.position)
    .map((item) => ({ label: item.name, value: item.id }));

  const endPathOptions = getPathOptions(editedEndInternalGrade.gradeId);

  const cancelEditing = () => {
    resetEditedFields();
    setIsEditable(false);
  };

  const getPathIdByPathGradeId = (pathGradeId: number | null) => {
    if (pathGradeId == null || !selectedYearConfig) {
      return null;
    }

    const pathGrade = selectedYearConfig.pathGrades.find(
      (item) => item.id === pathGradeId,
    );

    return (
      selectedYearConfig.paths.find((item) => item.id === pathGrade?.pathId)
        ?.id ?? null
    );
  };

  const onSubmit = async () => {
    const body: UpdateCollaboratorResumeRequest = {
      indicators: indicators.map((item, index) => ({
        microCriterio: item.microCriterio,
        total: editedIndicators[index] ?? item.total,
      })),
      collaboratorIncreasings: editedIncreasings,
      endInternalGrade: {
        ...editedEndInternalGrade,
        pathId: getPathIdByPathGradeId(editedEndInternalGrade.pathGradeId),
      },
    };

    if (onResumeChange) {
      onResumeChange(body);
      setIsEditable(false);
      return;
    }

    if (!updateResume) {
      return;
    }

    try {
      await updateResume(body);
      setIsEditable(false);
      notification.success(DATA_ADDED_SUCCESS_LABEL, undefined, "toast");
    } catch (error) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  };

  const handleConfirmSave = () => {
    setShowSaveConfirm(false);
    onSubmit();
  };

  useEffect(() => {
    if (!planSelected) return;

    resetEditedFields();
  }, [planSelected, data, localResume]);

  useEffect(() => {
    const developmentScreen = planSelected?.developmentScreen;
    if (!onCalibrationChange || !developmentScreen) return;

    const nextDimensionId =
      planSelected?.dimensionId ?? pendingCalibration?.finalDimensionId ?? 0;

    if (
      pendingCalibration &&
      pendingCalibration.finalScreen === developmentScreen.screen &&
      pendingCalibration.finalDimensionPercentage ===
        developmentScreen.totalIndicators &&
      pendingCalibration.finalDimensionId === nextDimensionId
    ) {
      return;
    }

    onCalibrationChange({
      finalDimensionId: nextDimensionId,
      finalScreen: developmentScreen.screen,
      finalDimensionPercentage: developmentScreen.totalIndicators,
      finalComment: pendingCalibration?.finalComment ?? null,
    });
  }, [
    planSelected?.developmentScreen?.screen,
    planSelected?.developmentScreen?.totalIndicators,
    planSelected?.dimensionId,
    pendingCalibration,
    onCalibrationChange,
  ]);

  const indicators = planSelected?.developmentScreen?.indicators ?? [];

  const indicatorOptions = Array.from({ length: 13 }, (_, value) => ({
    value,
    label: value.toString(),
  }));

  const printDisabled = loading || isEditable;

  useEffect(() => {
    if (!printButton) {
      return;
    }

    printButton(
      <Button
        icon={<PrintIcon />}
        variant={ButtonVariants.PRIMARY}
        size={ButtonSizes.SMALL}
        label={PRINT_LABEL}
        disabled={printDisabled}
        onClick={print}
      />,
    );
  }, [printDisabled]);

  const getIncreasingIcon = (
    increasingEnum: CollaboratorIncreasingEnum | null | undefined,
  ) => {
    return increasingEnum === CollaboratorIncreasingEnum.YES ? (
      <IconManager size={IconSizeEnum.MEDIUM} color={theme.colors.green}>
        <CheckIcon />
      </IconManager>
    ) : increasingEnum === CollaboratorIncreasingEnum.NO ? (
      <IconManager size={IconSizeEnum.MEDIUM} color={theme.colors.red_1}>
        <CloseIcon />
      </IconManager>
    ) : (
      <IconManager size={IconSizeEnum.MEDIUM} color={theme.colors.orange_1}>
        <EvaluateIcon />
      </IconManager>
    );
  };

  const increasingOptions = [
    { label: YES_LABEL, value: CollaboratorIncreasingEnum.YES },
    { label: NO_LABEL, value: CollaboratorIncreasingEnum.NO },
    {
      label: TO_EVALUATE_LABEL,
      value: CollaboratorIncreasingEnum.ANALYSIS_REQUIRED,
    },
  ];

  const increasingRows = [
    { label: INTERNAL_GRADE_PASS_LABEL, key: "internalGradeIncrease" },
    { label: CCNL_LEVELL_PASS_LABEL, key: "ccnlIncrease" },
    { label: INCREASE_LABEL, key: "salaryIncrease" },
  ] as const;

  return (
    <div>
      <Accordion
        label={
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {PROGRESS_PLAN_LABEL}
          </BodyTyp>
        }
        variant={AccordionVariantEnum.SECONDARY}
        leftComponent={
          <IconManager size={IconSizeEnum.SMALL}>
            <ProgressIcon />
          </IconManager>
        }
        rightComponent={
          setSelectedYear &&
          yearOptions && (
            <div className="filter-buttons-container">
              <TextSwitch
                selectedOption={selectedYear}
                setSelectedOption={setSelectedYear}
                options={yearOptions}
                disabled={isEditable}
              />
            </div>
          )
        }
        onToggle={setIsAccordionOpen}
        isOpen={isAccordionOpen}
      >
        {btnEditIsToView
          ? roleHasPermission(profile, PermissionsEnum.EDIT_RESUME) &&
            cmSheetIsCurrent &&
            editButton &&
            editButton.visible &&
            !isEditable && (
              <StyledBtnModifyContainer>
                <Button
                  icon={<EditIcon />}
                  label={EDIT_LABEL}
                  variant={ButtonVariants.SECONDARY}
                  onClick={() => setIsEditable(!isEditable)}
                  disabled={editButton.disabled}
                  size={ButtonSizes.SMALL}
                />
              </StyledBtnModifyContainer>
            )
          : null}
        <form
          onSubmit={(event) => event.preventDefault()}
          id={`resume-form-${collaborator.id}`}
        >
          <StyledBodyProgressPlan>
            <div className="page-break">
              <StyledProgressPlanHeader>
                <div>
                  <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
                    {DEVELOPMENT_SCREEN_LABEL}
                  </BodyTyp>
                  <InfoContainer variant="2">
                    <FinalInterviewInfo
                      title={planSelected?.developmentScreen?.screen ?? null}
                      description={
                        planSelected?.developmentScreen?.description ??
                        EMPTY_DEVELOPMENT_SCREEN_LABEL
                      }
                      label={
                        planSelected?.developmentScreen?.range &&
                        `Range ${planSelected?.developmentScreen?.range[0]} - ${planSelected?.developmentScreen?.range[1]}`
                      }
                      withBackground={false}
                      icon={<QuadrantIcon />}
                    />
                  </InfoContainer>
                </div>
                <div>
                  <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
                    {VALUTATION_MATRIX_OF_DEVELOPMENT_LABEL}
                  </BodyTyp>
                  {planSelected?.developmentScreen && (
                    <StyledValutationQuadrantContainer>
                      {indicators.map((item, index) => (
                        <StyledValutationQuadrantBody key={index}>
                          <BodyTyp variant="2">{item.microCriterio}</BodyTyp>
                          {isEditable ? (
                            <StyledValutationQuadrantSelect>
                              <Select
                                variant={SelectVariantEnum.DEFAULT}
                                size={InputSizes.SMALL}
                                options={indicatorOptions}
                                value={editedIndicators[index] ?? null}
                                allowClear={false}
                                onChange={(value) =>
                                  setEditedIndicators((prev) =>
                                    prev.map((total, i) =>
                                      i === index ? (value ?? 0) : total,
                                    ),
                                  )
                                }
                              />
                            </StyledValutationQuadrantSelect>
                          ) : (
                            <BodyTyp
                              fontWeight={FontWeightEnum.SEMIBOLD}
                              variant="1"
                            >
                              {initialEditedFields.indicators[index] ??
                                item.total}
                            </BodyTyp>
                          )}
                        </StyledValutationQuadrantBody>
                      ))}
                      {indicators.length % 2 === 1 && (
                        <StyledValutationQuadrantBody />
                      )}
                      <StyledValutationQuadrantTotal>
                        <BodyTyp
                          variant="1"
                          fontWeight={FontWeightEnum.SEMIBOLD}
                        >
                          {TOTAL_LABEL}
                        </BodyTyp>
                        <BodyTyp
                          variant="1"
                          fontWeight={FontWeightEnum.SEMIBOLD}
                          color={theme.colors.purple}
                        >
                          {isEditable
                            ? editedIndicators.reduce(
                                (total, value) => total + value,
                                0,
                              )
                            : localResume
                              ? initialEditedFields.indicators.reduce(
                                  (total, value) => total + value,
                                  0,
                                )
                              : planSelected?.developmentScreen
                                  ?.totalIndicators}
                        </BodyTyp>
                      </StyledValutationQuadrantTotal>
                    </StyledValutationQuadrantContainer>
                  )}
                </div>
              </StyledProgressPlanHeader>
            </div>
            <div className="page-break">
              <StyledProgressPlanBody $isEditable={isEditable}>
                <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
                  {PROPOSAL_STEPS_INCREASER_LABEL}
                </BodyTyp>
                <StyledRowIncreasingContainer>
                  {increasingRows.map((row) => (
                    <StyledRowIncreasing key={row.key}>
                      <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
                        {row.label}
                      </BodyTyp>
                      {isEditable ? (
                        <StyledIncreasingRadioGroup>
                          {increasingOptions.map((option) => (
                            <StyledIncreasingRadioOption key={option.value}>
                              <RadioButton
                                name={`increasing-${row.key}`}
                                value={
                                  editedIncreasings[row.key] === option.value
                                }
                                onChange={() =>
                                  setEditedIncreasings((prev) => ({
                                    ...prev,
                                    [row.key]: option.value,
                                  }))
                                }
                              />
                              <BodyTyp
                                variant="2"
                                fontWeight={FontWeightEnum.REGULAR}
                              >
                                {option.label}
                              </BodyTyp>
                            </StyledIncreasingRadioOption>
                          ))}
                        </StyledIncreasingRadioGroup>
                      ) : (
                        getIncreasingIcon(
                          initialEditedFields.increasings[row.key],
                        )
                      )}
                    </StyledRowIncreasing>
                  ))}
                </StyledRowIncreasingContainer>
              </StyledProgressPlanBody>
            </div>
            <div>
              <StyledWorkInformationTitle>
                <IconManager
                  size={IconSizeEnum.SMALL}
                  color={theme.colors.black}
                >
                  <InternalGradeIcon />
                </IconManager>
                <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
                  {INTERNAL_GRADE_END_LABEL}
                </BodyTyp>
              </StyledWorkInformationTitle>
              {isEditable && selectedYearConfig ? (
                <StyledGridContainer $isComparison={isComparison}>
                  <Select
                    variant={SelectVariantEnum.MULTI_SELECT}
                    label={JOB_FAMILY_LABEL}
                    options={selectedYearConfig.jobFamilies.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    value={editedEndInternalGrade.jobFamilyListId}
                    onChange={(value) =>
                      setEditedEndInternalGrade((prev) => ({
                        ...prev,
                        jobFamilyListId: value,
                      }))
                    }
                    maxSelections={2}
                  />
                  <Select
                    variant={SelectVariantEnum.SINGLE_SELECT}
                    label={GRADE_LABEL}
                    options={endGradeOptions}
                    value={editedEndInternalGrade.gradeId}
                    onChange={(value) =>
                      setEditedEndInternalGrade((prev) => ({
                        ...prev,
                        gradeId: value,
                        pathGradeId: null,
                        subgradeId: null,
                      }))
                    }
                  />
                  {endPathOptions.length > 0 ? (
                    <>
                      <Select
                        variant={SelectVariantEnum.SINGLE_SELECT}
                        label={PATH_LABEL}
                        options={endPathOptions}
                        value={editedEndInternalGrade.pathGradeId}
                        onChange={(value) =>
                          setEditedEndInternalGrade((prev) => ({
                            ...prev,
                            pathGradeId: value,
                          }))
                        }
                      />
                      <Select
                        variant={SelectVariantEnum.SINGLE_SELECT}
                        label={SUBGRADE_LABEL}
                        options={selectedYearConfig.subgrades.map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        value={editedEndInternalGrade.subgradeId}
                        onChange={(value) =>
                          setEditedEndInternalGrade((prev) => ({
                            ...prev,
                            subgradeId: value,
                          }))
                        }
                      />
                    </>
                  ) : (
                    <>
                      <TextBox label={PATH_LABEL} text={EMPTY_STRING} />
                      <TextBox label={SUBGRADE_LABEL} text={EMPTY_STRING} />
                    </>
                  )}
                </StyledGridContainer>
              ) : (
                <StyledGridContainer $isComparison={isComparison}>
                  <TextBox
                    label={JOB_FAMILY_LABEL}
                    text={displayEndInternalGrade?.jobFamilies}
                  />
                  <TextBox
                    label={GRADE_LABEL}
                    text={displayEndInternalGrade?.grade}
                  />
                  <TextBox
                    label={PATH_LABEL}
                    text={displayEndInternalGrade?.path}
                  />
                  <TextBox
                    label={SUBGRADE_LABEL}
                    text={displayEndInternalGrade?.subGrade}
                  />
                </StyledGridContainer>
              )}
            </div>
            {isEditable && (
              <StyledBtnEditContainer>
                <div>
                  <Button
                    type="button"
                    icon={<CloseIcon />}
                    label={CANCEL_LABEL}
                    variant={ButtonVariants.SECONDARY}
                    onClick={() => cancelEditing()}
                    size={ButtonSizes.REGULAR}
                  />
                  <Button
                    type="button"
                    icon={<SaveIcon />}
                    label={SAVE_LABEL}
                    variant={ButtonVariants.PRIMARY}
                    disabled={loading || !isDirty}
                    onClick={() =>
                      onResumeChange ? onSubmit() : setShowSaveConfirm(true)
                    }
                    size={ButtonSizes.REGULAR}
                  />
                </div>
              </StyledBtnEditContainer>
            )}
          </StyledBodyProgressPlan>
        </form>
      </Accordion>
      <PopupConfirm
        label={MODIFY_RESUME_DEVELOPMENT_PLAN_LABEL}
        isOpen={showSaveConfirm}
        onConfirm={handleConfirmSave}
        onCancel={() => setShowSaveConfirm(false)}
        popupText={MODIFY_RESUME_DEVELOPMENT_PLAN_MESSAGE}
      />
    </div>
  );
};
